














import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'team-intro',
})
export default class TeamIntro extends Vue { }
